__turbopack_context__.v({
  "link": "nmC4qq_link",
  "skipLinks": "nmC4qq_skipLinks",
});
